module.exports = __webpack_public_path__ + "static/media/gallery4.bfa23471.png";